import { render, staticRenderFns } from "./InitialComponent.vue?vue&type=template&id=241cdded&scoped=true&"
import script from "./InitialComponent.vue?vue&type=script&lang=js&"
export * from "./InitialComponent.vue?vue&type=script&lang=js&"
import style0 from "./InitialComponent.vue?vue&type=style&index=0&id=241cdded&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/katonobo/Documents/Web App/dream-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cdded",
  null
  
)

export default component.exports